import loadScriptAsync from '../loadScriptAsync'
import debug from '../console'
const logger = debug.withTag('utils:preAYScripts')

export const preAYScripts = async () => {
  /**
   * Launchpad carries the CMP, and LiveRamp is explicit that the CMP has to be up
   * before ATS and the consent-gated calls that depend on it — so this has to
   * settle before AY bootstraps.
   */
  await loadScriptAsync(
    'head',
    {
      src: `https://launchpad-wrapper.privacymanager.io/528606c5-a8ba-42f7-be55-93209da0477d/launchpad-liveramp.js`,
      key: 'liveramp',
    },
    { defer: true }
  ).catch((error) => {
    logger.warn(
      'Failed to load LiveRamp identity module, continuing without enhanced targeting',
      error
    )
  })
}
